var flatpickres = {};

function dtLocalization() {
    var name = "_culture=";
    var ca = document.cookie.split(';');
    var value = "";
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1)
            value = c.substring(name.length, c.length);
    }
    if (value == "en-US") value = "";
    if (value == "nn-NO") value = "no-NN";
    value = value.split("-")[0];
    return String(value)
}

function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month;
}

function getDay(date) {
    var day = date.getDate();
    return day < 10 ? '0' + day : '' + day;
}

function getMinutes(date) {
    var minutes = date.getMinutes();
    return minutes < 10 ? '0' + minutes : '' + minutes;
}

function validateFlatPickrDate(inputText) {
    var dateformat = /^\d{4}[\/\-](0[1-9]|1[012])[\/\-](0[1-9]|[12][0-9]|3[01])( ((0[0-9]|1[0-9]|2[0123])(:([0-5][0-9])){1}))$/gm;
    // Match the date format through regular expression
    if((m = dateformat.exec(inputText)) !== null && !!inputText) {
        //document.form1.text1.focus();
        //Test which seperator is used '/' or '-'
        var opera1 = inputText.split('/');
        var opera2 = inputText.split('-');
        lopera1 = opera1.length;
        lopera2 = opera2.length;
        // Extract the string into month, date and year
        if (lopera1>1) {
            var pdate = inputText.split('/');
        } else if (lopera2>1) {
            var pdate = inputText.split('-');
        }
        var mm  = parseInt(pdate[0]);
        var dd = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);
        // Create list of days of a month [assume there is no leap year by default]
        var ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
        if (mm==1 || mm>2) {
            if (dd>ListofDays[mm-1]) {
                return false;
            }
        }
        if (mm==2) {
            var lyear = false;
            if ( (!(yy % 4) && yy % 100) || !(yy % 400)) {
                lyear = true;
            }
            if ((lyear==false) && (dd>=29)) {
                return false;
            }
            if ((lyear==true) && (dd>29)) {
                return false;
            }
        }
    } else if (inputText) {
        return false;
    }
    return true;
}

function repairDate(selector, altFormat, dateFormat, enableTime, other) {
    $(selector).each(function () {
        var value = $(this).val();

        var dp = $(this).flatpickr(Object.assign({
            locale: getLanguage(),
            time_24hr: true,
            enableTime: enableTime,
            defaultDate: value,
            disableMobile: true,
            altFormat: altFormat,
            dateFormat: dateFormat,
            allowInput: true,
            altInput: true,
            onReady: function(_1, _2, pickr) {
                // new Cleave(pickr._input, {
                //     date: true,
                //     delimiters: ['-', '-', ' ', ':'],
                //     datePattern: ['Y', 'm', 'd', 'hh', 'mm'],
                // });
            },
            plugins: [
                FlatPickrButtonPlugin({
                    button: {
                        label: '<i class="material-icons">today</i>'
                    },
                    onClick: function (fp) {
                        fp.setDate(new Date(Date.now()));
                    },
                    onKeyUp: function(pickr, e) {
                        if (e.keyCode === 8 && e.target.value === "") {
                            pickr.clear();
                            pickr.close();
                        } else {
                            if (validateFlatPickrDate(e.target.value)) {
                                console.log(2, e.target.value,pickr);
                                pickr.setDate(e.target.value);
                            }
                        }
                    }
                })
            ]
        }, other));

        var id = $(this).attr('id');

        if (id) {
            flatpickres[id] = dp;
        }
    });
}

function initFlatpickr() {
    repairDate('.datetimepicker, .datepicker', 'Y-m-d H:i', 'Y-m-d H:i:S', true, {});
}

$(document).ajaxComplete(function () {
    initFlatpickr();
    
    $('.collapsible').collapsible();
    $('select:not(.searchEnum):not(.flatpickr-monthDropdown-months)').material_select();
});
$(document).ready(function () {
    $('.datepicker').each(function () {

        var format = $(this).val();

        if (format != 0) {

            current = new Date(format);

            function getMonth(date) {
                var month = date.getMonth() + 1;
                return month < 10 ? '0' + month : '' + month;
            }
            function getDay(date) {
                var day = date.getDate();
                return day < 10 ? '0' + day : '' + day;
            }


            newDate = current.getFullYear() + "-" + getMonth(current) + "-" + getDay(current);
            $(this).val(newDate);

        }

    });

    initFlatpickr();
});